function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.35192 10.7515C7.33296 10.7515 7.29504 10.7515 7.25713 10.7326L3.38956 9.72774C3.35164 9.70878 3.31372 9.7467 3.31372 9.78462V14.3916C3.31372 14.4295 3.33268 14.4485 3.3706 14.4485L9.57009 16.0789C9.60801 16.0979 9.64592 16.0599 9.64592 16.022V8.43855C9.64592 8.38167 9.57009 8.34376 9.53217 8.40063L7.61734 10.6378C7.54151 10.7136 7.44671 10.7515 7.35192 10.7515Z",
  fill: "currentcolor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.98714 4.0022L4.58392 5.4241C4.52704 5.44306 4.52704 5.53785 4.58392 5.55681L9.98714 6.97871C10.0061 6.97871 10.0061 6.97871 10.0251 6.97871L15.4283 5.55681C15.4852 5.53785 15.4852 5.44306 15.4283 5.4241L10.0251 4.0022C10.0061 4.0022 10.0061 4.0022 9.98714 4.0022Z",
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6604 10.7515C12.5656 10.7515 12.4708 10.7135 12.395 10.6377L10.4612 8.40059C10.4232 8.36267 10.3474 8.38163 10.3474 8.4385V16.0409C10.3474 16.0789 10.3853 16.1168 10.4232 16.0978L16.6417 14.4674C16.6607 14.4674 16.6986 14.4294 16.6986 14.4105V9.80353C16.6986 9.76561 16.6607 9.72769 16.6227 9.74665L12.7741 10.7515C12.7172 10.7515 12.6793 10.7515 12.6604 10.7515Z",
  fill: "currentcolor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.812 10.0122L18.9547 8.40068C18.9926 8.38172 19.0115 8.32485 18.9926 8.28693L16.945 5.91709C16.9261 5.89813 16.9071 5.89813 16.8882 5.89813L10.7456 7.50962C10.7076 7.52858 10.6887 7.58546 10.7076 7.62337L12.7552 10.0122C12.7741 10.0122 12.7931 10.0122 12.812 10.0122Z",
  fill: "currentcolor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28572 7.50962L3.1431 5.89813C3.12414 5.89813 3.08622 5.89813 3.08622 5.91709L1.01973 8.28693C0.981809 8.32485 1.00077 8.38172 1.05764 8.40068L7.20026 10.0122C7.21922 10.0122 7.25714 10.0122 7.25714 9.99321L9.30467 7.60441C9.34259 7.5665 9.32363 7.50962 9.28572 7.50962Z",
  fill: "currentcolor"
});

const SvgBox = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box.72d2a680.svg";
export { ForwardRef as ReactComponent };